/* eslint-disable no-unused-vars */
// Sorting values expected by the backend API payload
export enum EXPLORE_SORT {
  MOST_SOLD = "most_sold",
  RELEVANCE = "relevance",
  MOST_VIEWED = "most_viewed",
  NEWEST = "newest",
  TREND_COUNT = "trend_count",
  PRODUCT_COUNT = "product_count",
}

// Sorting values used in the frontend URL query string (?sort=...)
export enum EXPLORE_SORT_QUERY {
  POPULAR = "popular",
  RELEVANT = "relevant",
  VIRAL = "viral",
  NEWEST = "newest",
  TREND_COUNT = "trend_count",
  PRODUCT_COUNT = "product_count",
}

export const EXPLORE_SORT_TO_QUERY: Record<EXPLORE_SORT, EXPLORE_SORT_QUERY> = {
  [EXPLORE_SORT.MOST_SOLD]: EXPLORE_SORT_QUERY.POPULAR,
  [EXPLORE_SORT.RELEVANCE]: EXPLORE_SORT_QUERY.RELEVANT,
  [EXPLORE_SORT.MOST_VIEWED]: EXPLORE_SORT_QUERY.VIRAL,
  [EXPLORE_SORT.NEWEST]: EXPLORE_SORT_QUERY.NEWEST,
  [EXPLORE_SORT.TREND_COUNT]: EXPLORE_SORT_QUERY.TREND_COUNT,
  [EXPLORE_SORT.PRODUCT_COUNT]: EXPLORE_SORT_QUERY.PRODUCT_COUNT,
};

export const normalizeExploreSortQuery = (sort: string): string => {
  if ((Object.values(EXPLORE_SORT) as string[]).includes(sort)) {
    return EXPLORE_SORT_TO_QUERY[sort as EXPLORE_SORT];
  }
  return sort;
};

export const isApiSortInQuery = (sort: string): boolean => {
  const isApiValue = (Object.values(EXPLORE_SORT) as string[]).includes(sort);
  const isQueryValue = (Object.values(EXPLORE_SORT_QUERY) as string[]).includes(
    sort
  );
  return isApiValue && !isQueryValue;
};
